module.exports = __webpack_public_path__ + "static/media/ic_jiaofeng.87112f02.png";